module.exports = __webpack_public_path__ + "25fe5dcd0b96d46d6e71377695553752.png";